<template>
  <div class="agreement">
    <label class="agreement-check">
      <input type="checkbox" :checked="value" @change="onChange" />
      <span>
        我已阅读并同意
        <a href="javascript:void(0);" @click.prevent="open('service')">《服务协议》</a>
        <a href="javascript:void(0);" @click.prevent="open('privacy')">《用户隐私说明》</a>
      </span>
    </label>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="70%"
      top="8vh"
      append-to-body
      custom-class="agreement-dialog"
    >
      <div class="agreement-body" v-html="dialogContent"></div>
    </el-dialog>
  </div>
</template>

<script>
import agreements from '../constants/agreements'

export default {
  name: 'Agreement',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '',
      dialogContent: '',
    }
  },
  methods: {
    onChange(e) {
      this.$emit('input', e.target.checked)
    },
    open(type) {
      const item = agreements[type]
      if (!item) return
      this.dialogTitle = item.title
      this.dialogContent = item.content
      this.dialogVisible = true
    },
  },
}
</script>

<style scoped>
.agreement {
  margin-top: 1rem;
  text-align: left;
  font-size: 13px;
  color: #666;
  line-height: 1.6;
}

.agreement-check {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
}

.agreement-check input {
  margin-top: 3px;
  flex-shrink: 0;
}

.agreement a {
  color: #4571db;
  text-decoration: none;
}

.agreement a:hover {
  text-decoration: underline;
}

.agreement-body {
  max-height: 60vh;
  overflow-y: auto;
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  padding-right: 8px;
}
</style>
